













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class CarrouselInformativa extends Vue {
  @Prop({ default: true }) show!: boolean;
  @Prop({ default: [] }) elementos!: any;

  locations: any = [];
  labels: any = [];

  mounted() {}
}
